export default {
    permissoes: [],
    permissoesRegras: [],
    permissao: {},
    regras: [],
    regra: {}
}